import { G, BR, T2, PILARES } from "../theme";

export default function Radar(props) {
  var scores = props.scores, N = PILARES.length, cx = 130, cy = 130, r = 95;
  var rings = [], axes = [], poly = [], dots = [], lbls = [];
  for (var i = 0; i < N; i++) {
    var angle = (Math.PI*2*i)/N - Math.PI/2;
    var sc = scores[PILARES[i].key] || 0;
    var px = cx+(sc/10)*r*Math.cos(angle), py = cy+(sc/10)*r*Math.sin(angle);
    poly.push(px.toFixed(1)+","+py.toFixed(1));
    dots.push(<circle key={"d"+i} cx={px} cy={py} r="4" fill={G}/>);
    var lx = cx+(r+20)*Math.cos(angle), ly = cy+(r+20)*Math.sin(angle);
    lbls.push(<text key={"l"+i} x={lx} y={ly} textAnchor="middle" dominantBaseline="middle" fontSize="9" fill={T2}>{PILARES[i].label}</text>);
    axes.push(<line key={"a"+i} x1={cx} y1={cy} x2={cx+r*Math.cos(angle)} y2={cy+r*Math.sin(angle)} stroke={BR} strokeWidth="1"/>);
  }
  for (var rv = 2; rv <= 10; rv += 2) {
    var rpts = [];
    for (var k = 0; k < N; k++) {
      var ra = (Math.PI*2*k)/N - Math.PI/2;
      rpts.push((cx+(rv/10)*r*Math.cos(ra)).toFixed(1)+","+(cy+(rv/10)*r*Math.sin(ra)).toFixed(1));
    }
    rings.push(<polygon key={"r"+rv} points={rpts.join(" ")} fill="none" stroke={BR} strokeWidth="1"/>);
  }
  return (
    <svg viewBox="0 0 260 260" width="220" height="220">
      {rings}{axes}
      <polygon points={poly.join(" ")} fill={G+"33"} stroke={G} strokeWidth="1.5"/>
      {dots}{lbls}
    </svg>
  );
}
